import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";
import ja from "./ja.json";

Vue.use(VueI18n);

const messages = {
  ja: ja,
  en: en,
};

export const i18n = new VueI18n({
  locale: window.localStorage.getItem("language") || "ja",
  messages,
});
